module.exports = __webpack_public_path__ + "996ab6cd426c44e2f9e869e54927ba0d.svg";